// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1C4Um","content":"LayoutSettings_content__3HBBx"};